<template>
<div @mouseleave="()=>{card_show = false;}">
  <div class="tagsVary" :class="{'limit':fold}">
    <a-icon class="fold" :class="{'limit':fold}" :type="!fold?'menu-fold':'menu-unfold'" @click="foldNow()"/>

        <ul class="tagsObj clearfix" v-if="!fold">
          <!-- <li class="index" @click="toIndex()">
          <a-icon type="home" style="font-size:22px;float:left;margin-right:10px;margin-top:10px;"/>
            首页
          </li> -->
          <li
            :class="chooseTag === item ? 'activTags' : ''"
            v-for="(item, idx) in tags"
            :key="idx"
            @click="ChangeQuery(item)"
          >
          <default-icon :needTagImg="true" :isLeft="true" size="s10" :tag="item" style="width:25px;height:25px;float:left;margin-right:10px;margin-top:10px;"/>
          <span :title='item | noNum '>{{ item | noNum }}</span>
          </li>
        </ul>
  </div>
  <cards :visi="card_show" />
</div>
</template>

<script>
import Cards from './Cards.vue';
export default {
  name: "TagVaries",
  data() {
    return {
      chooseTag: "all",
      card_show:false,
      fold:false

    };
  },
  components: {
    Cards
  },
  computed: {
    tags() {
      return this.$store.getters.getTags;
    },
    department() {
      return this.$store.getters.getDep;
    },
    alltags(){
      let obj = this.$store.getters.getOtherTags;
      for(let o in obj){
        obj[o] = Array.from(new Set(obj[o]) ).sort();
      }
      console.log(obj);
      return obj;
    }
  },
  methods: {
    ChangeQuery(val){
      this.chooseTag = val;
      this.card_show = true;
      this.$store.dispatch("updateQuery", { tag: val });
    },
    foldNow(){
      this.fold = !this.fold;
      this.$emit('limit',this.fold);
    },
    toIndex(){
        this.$router.push(`/workflow/index`);
    }
  },
};
</script>
<style scoped>
.pc .tagsVary{
	background-color: #0062AC;
	width: 165px;
  position:fixed;
  left:0px;
  top:0px;
	height:100vh;
	overflow: hidden;
  z-index:20;
}
.pc .tagsVary.limit{
  width:40px;
}
.tagsVary_div {
  overflow: hidden;
  min-height: 50px;
  width: 100%;
  padding-top: 7px;
  border-bottom: 1px #ddd solid;
}
.tagsVary_title {
  width: 80px;
  height: 36px;
  float: left;
  display: inline;
  line-height: 36px;
  text-align: center;
  color: #333;
  font-weight: 600;
}
.tagsVary .fold {
 display: block;
 /*! float: left; */color: #fff;
 font-size: 25px;
 text-align: left;
 padding-left: 4%;
 padding: 10px 4%;
}
.tagsVary .fold.limit{
text-align: center;
padding: 10px 0px;
}
.tagsObj li{
  color: #fff;
  display: block;
  padding-left: 8px;
  padding-right: 8px;
  line-height: 45px;
  cursor:pointer;
  width:94%;
  border-radius: 10px;
  margin:0px auto;
  margin-bottom:5px;
  height: 45px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 16px;
}
.tagsObj li.index {
 background: #fff;
 color: #0062AC;
}

.tagsObj li:not(.index):hover {
  background-color: #003f6f;
}
.tagsObj .activTags {
  background-color: #003f6f;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/Tags.vue